export default __webpack_public_path__ + "static/media/021-party hat.75bee280.svg";